<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('General') }}</legend>
                                                        <checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />

                            <text-input label="Name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <select-input label="supplier_group_id" v-model="form.supplier_group_id" >
                                <option :value="null">{{ __('Keine') }}</option>
                                <option :value="supplierGroup.id" v-for="supplierGroup in supplierGroups">{{ supplierGroup.name }}</option>
                            </select-input>
                            <text-input label="Kurzname" v-model="form.short_name" :error="form.errors.short_name" />
                            <text-input label="logo" v-model="form.logo" :error="form.errors.logo" />
                            <text-input label="default_product_image_id" v-model="form.default_product_image_id" :error="form.errors.default_product_image_id" />
                            <!--@todo attachment select-->
                            <div class="row">
                                <div class="col-sm-8">
                                    <text-input label="Straße" v-model="form.street" :error="form.errors.street" />
                                </div>
                                <div class="col-sm-4">
                                    <text-input label="Hausnr." v-model="form.house_number" :error="form.errors.house_number" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <text-input label="PLZ" v-model="form.zip_code" :error="form.errors.zip_code" />
                                </div>
                                <div class="col-sm-8">
                                    <text-input label="Ort" v-model="form.city" :error="form.errors.city" />
                                </div>
                            </div>
                            <select-input label="Land" v-model="form.country_id" :error="form.errors.country_id">
                                <option :value="null">{{ __('Please select') }}</option>
                                <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                            </select-input>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Kontaktdaten') }}</legend>
                            <text-input label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                            <text-input label="fax" v-model="form.fax" type="tel" :error="form.errors.fax" />
                            <text-input label="email" v-model="form.email" type="email" :error="form.errors.email" />
                            <text-input label="order_email" v-model="form.order_email" type="email" :error="form.errors.order_email" />
                            <text-input label="contact_email" v-model="form.contact_email" type="email" :error="form.errors.contact_email" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Steuern') }}</legend>
                            <text-input label="Registernr." v-model="form.register_number" :error="form.errors.register_number" />
                            <text-input label="Ust-ID" v-model="form.vat_id" :error="form.errors.vat_id" />
                        </fieldset>
                        <fieldset>
                            <legend>{{ __('Kennungen') }}</legend>
                            <text-input label="gln" v-model="form.gln" :error="form.errors.gln" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>

                            <legend>{{ __('Informationen') }}</legend>

                            <!--@todo nur admins anzeigen-->
                            <!--<text-input label="Scoring" v-model="form.scoring" type="number" :error="form.errors.scoring" />-->
                            <text-input 
                                label="Website"
                                v-model="form.website" 
                                :error="form.errors.website" 
                                />

                            <text-input 
                                label="AGB URL" 
                                v-model="form.terms_url" 
                                type="url" 
                                :error="form.errors.terms_url" 
                                />

                            <editor-input 
                                label="description" 
                                v-model="form.description" 
                                :error="form.errors.description"
                                />

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>

                            <legend>{{ __('SEO') }}</legend>

                            <text-input 
                                label="Meta-Title"
                                v-model="form.meta_title" 
                                :error="form.errors.meta_title" 
                                />

                            <textarea-input 
                                label="Meta-Description" 
                                v-model="form.meta_description" 
                                :error="form.errors.meta_description" 
                                />

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>

                            <legend>{{ __('Import') }}</legend>

                            <select-input 
                                label="import_mode" 
                                v-model="form.import_mode" 
                                :error="form.errors.import_mode"
                                >
                                <option :value="null">{{ __('None') }}</option>
                                <option v-for="(v, k) in importModeOptions" :value="k">{{ v }}</option>
                            </select-input>

                            <select-input 
                                label="default_import_type" 
                                v-model="form.default_import_type" 
                                :error="form.errors.default_import_type"
                                >
                                <option :value="null">{{ __('None') }}</option>
                                <option v-for="(v, k) in importTypeOptions" :value="k">{{ v }}</option>
                            </select-input>

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>

                            <legend>{{ __('Prices') }}</legend>

                            <price-input 
                                label="general_product_price" 
                                v-model="form.general_product_price" 
                                :error="form.errors.general_product_price"
                                :help="__('Dieser Wert überschreibt alle definierten Produktpreise dieses Lieferanten. Kann auch 0 betragen.')"
                                />

                            <editor-input 
                                label="general_product_price_text" 
                                v-model="form.general_product_price_text"
                                :error="form.errors.general_product_price_text" 
                                :help="__('Hinweistext wird auf der Produktdetailseite ausgegeben.')"
                                />

                            <select-input 
                                label="default_product_price_type" 
                                v-model="form.default_product_price_type" 
                                :error="form.errors.default_product_price_type"
                                >
                                <option :value="null">{{ __('Default') }}</option>
                                <option v-for="(v, k) in priceTypeOptions" :value="k">{{ v }}</option>
                            </select-input>

                        </fieldset>

                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Intern') }}</legend>
                            <textarea-input label="Notizen" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>

                            <legend>{{ __('Options') }}</legend>

                            <!--@todo validation-->
                            <checkbox-input 
                                label="customers_must_have_relation" 
                                v-model="form.account_options.customers_must_have_relation" 
                                :help="__('Kunden müssen für den Einkauf manuell freigeschaltet werden.')"
                                />

                            <text-input 
                                label="customers_must_have_relation_url"
                                v-model="form.account_options.customers_must_have_relation_url"
                                />

                            <checkbox-input 
                                label="allow_order_despite_empty_stock" 
                                v-model="form.account_options.allow_order_despite_empty_stock" 
                                :help="__('Händler akzeptiert Bestellungen seiner Produkte, auch wenn Bestand <= 0 ist.')" 
                                />

                            <editor-input 
                                label="document_default_content" 
                                v-model="form.account_options.document_default_content"
                                />

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="supplier">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import EditorInput from '@/shared/Inputs/EditorInput';

    export default {
        props: [
            'form',
            'supplier',
            'countries',
            'supplierGroups',
            'priceTypeOptions',
            'importModeOptions',
            'importTypeOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            PriceInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            EditorInput,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.suppliers.destroy', this.supplier));
            },

        },
    }
</script>
